import React from 'react';
import { PrivacyProtectionTable } from '../PrivacyProtection/PrivacyProtectionTable';
import '../../styles/PrivacyProtection.scss';
import { CONSTANTS } from '../../constants';

export const PrivacyProtection = ({ apiDetails }) => {
  const { apiDisplayName } = apiDetails;
  return (
    <div
      data-testid="step-privacy-protection"
      className="privacy-protection__container"
    >
      <p
        data-testid="privacy-protection-description"
        className="privacy-protection__description"
      >
        {CONSTANTS.PRIVACY_PROTECTION_DESCRIPTION}
      </p>
      <PrivacyProtectionTable apiName={apiDisplayName} />
    </div>
  );
};
